import React from "react";
import { Icon } from "antd";

const InfoCard = ({ icon, dotColor, label, value, extra }) => {
  return (
    <div className="campaignDetail__infoCard">
      <div className="campaignDetail__infoCard-top">
        {dotColor ? (
          <span
            className="campaignDetail__infoCard-dot"
            style={{ backgroundColor: dotColor }}
          />
        ) : (
          <Icon className="campaignDetail__infoCard-icon" type={icon} />
        )}
        {extra ? (
          <span className="campaignDetail__infoCard-extra">{extra}</span>
        ) : null}
      </div>
      <span className="campaignDetail__infoCard-label">{label}</span>
      <span className="campaignDetail__infoCard-value">{value}</span>
    </div>
  );
};

export default InfoCard;
